import * as React from "react";
import { Table } from "../../newcomponents/table/table";
import { TagsColumn } from "../../newcomponents/table/columns/wellKnown/tagsColumn";
import { CreatedColumn } from "../../newcomponents/table/columns/wellKnown/createdColumn";
import { LastModifiedColumn } from "../../newcomponents/table/columns/wellKnown/lastModifiedColumn";
import { linksOf } from "../../services/cpln";
import { Org } from "../../schema/types/org/entity";
import { useNavigate } from "react-router-dom";
import { Alert, Button } from "antd";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { selectOrgs } from "../../store/userDataSlice";
import { setOrg } from "../../store/contextSlice";
import { PlusCircleOutlined } from "@ant-design/icons";

interface OrgTableItem extends Org {
  accountId: string;
  accountName: string;
  selfLink: string;
}

export const OrgList: React.FC = () => {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const orgs = useAppSelector(selectOrgs);
  const orgAccountSummaryMap = useAppSelector((state) => state.userData.orgAccountSummaryMap);

  const orgTableItems: OrgTableItem[] = orgs.map((item) => {
    const selfLink = linksOf(item).self!;
    const account = orgAccountSummaryMap[item.name];
    const accountId = account?.id || "";
    const accountName = account?.accountName || account?.fullName || "";

    return {
      ...item,
      accountId: accountId,
      accountName: accountName,
      selfLink: selfLink,
    };
  });

  return (
    <>
      <Alert
        className="mb-6 w-fit"
        showIcon
        message={`Org Context`}
        description={`Select an org to navigate to Console dashboard with the org set as your context`}
      />
      <Table<OrgTableItem>
        title={"Orgs"}
        hideSettings
        headerRenderer={() => {
          return (
            <>
              <Button
                type={`primary`}
                className="action"
                onClick={() => navigate(`/home/org/-create`)}
                icon={<PlusCircleOutlined />}
              >
                New
              </Button>
            </>
          );
        }}
        data={orgTableItems}
        selectMode={`none`}
        tableId={`home-org-list-update1`}
        enableFilter
        columns={[
          {
            id: "name",
            label: "Name",
            cell: (p) => {
              const org = p.row.original;
              return (
                <div className="flex flex-col justify-center" style={{ height: 56 }}>
                    <a
                    href={`/console/org/${org.name}`}
                    onClick={(e) => {
                      if (e.button === 1 || e.ctrlKey || e.metaKey) {
                        return;
                      }
                      e.preventDefault();
                      dispatch(setOrg(org.name));
                      navigate(`/console/org/${org.name}`);
                    }}
                    className="color-link cursor-pointer"
                  >
                    {org.name}
                  </a>
                  {org.name === org.description ? null : <span className="text-sm description">{org.description}</span>}
                </div>
              );
            },
          },
          {
            id: "accountId",
            label: "Account Id",
            cell: (p) => {
              const org = p.row.original;
              return (
                <div className="flex flex-col justify-center" style={{ height: 56 }}>
                  <div>{org.accountName || org.accountId}</div>
                  {org.accountName === org.accountId ? null : (
                    <span className="text-sm description">{org.accountId}</span>
                  )}
                </div>
              );
            },
          },
          {
            id: "inactive",
            label: "Active",
            cell: (p) => {
              const org = p.row.original;

              if (!org.status?.active) {
                return <div className="color-danger">Inactive</div>;
              }

              return <div className="color-action">Active</div>;
            },
          },
          TagsColumn(),
          CreatedColumn(),
          LastModifiedColumn(),
        ]}
      />
    </>
  );
};
